import React, { useState, useEffect } from "react";
import { Input, Switch } from "antd";
import { useHistory } from "react-router-dom";

const SearchBar = ({ searchTerm, setSearchTerm, routerProps }) => {
  const { Search } = Input;
  const [input, setInput] = useState();
  const history = useHistory()

  function handleSearch(value) {
    const url = new URLSearchParams()
    url.set('filter', value)
    setSearchTerm(value);
    history.push(`/members?${url.toString()}`)
  }

  const handleFieldChange = (evt) => {
    const value = evt.target.value;
    setInput(value);
  };

  const handleEduClick = () => {
    setInput("edu")
    setSearchTerm("edu")
    history.push('/members?filter=edu')
  }

  return (
    <div className="productNavbar">
      <Search
        onChange={handleFieldChange}
        placeholder="Search member information . . ."
        onSearch={(value) => handleSearch(value)}
        value={input}
        enterButton
        allowClear
        style={{ width: "400px !important" }}
        className="searchBar"
      />
      <button onClick={handleEduClick}>.edu</button>
    </div>
  );
};

export default SearchBar;
